import { render, staticRenderFns } from "./StepDetails.vue?vue&type=template&id=0f81b202&scoped=true&"
import script from "./StepDetails.vue?vue&type=script&lang=js&"
export * from "./StepDetails.vue?vue&type=script&lang=js&"
import style0 from "./StepDetails.vue?vue&type=style&index=0&id=0f81b202&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f81b202",
  null
  
)

export default component.exports